import * as React from 'react';
import { useDeviceType } from '@cian/ui-kit';

import { FormContext } from '../../utils/formContext';
import { MobileContainerLayout } from './components/MobileContainerLayout/MobileContainerLayout';
import { DesktopContainerLayout } from './components/DesktopContainerLayout/DesktopContainerLayout';
import { trackBannerClose } from '../../utils/tracking';
import { useE2eLabelTracking } from '../../hooks';

export interface IContainerLayoutProps {
  title: string;
  content: React.ReactElement | string;
  actions: React.ReactElement;
  isWithRightSideImage: boolean;
  isWithRingLabelImage: boolean;
  actionsGap?: 8 | 16;
}

export const ContainerLayout: React.FC<IContainerLayoutProps> = props => {
  const context = React.useContext(FormContext);
  const isMobile = useDeviceType() === 'phone';
  const Component = isMobile ? MobileContainerLayout : DesktopContainerLayout;
  const onTrackBannerClose = useE2eLabelTracking(trackBannerClose);

  const onClose = () => {
    onTrackBannerClose({});
    context.onClose();
  };

  return <Component onClose={onClose} {...props} actionsGap={props.actionsGap || 8} />;
};
